import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ControlPointDuplicateOutlinedIcon from "@mui/icons-material/ControlPointDuplicateOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import SortableTree, {
  addNodeUnderParent,
  changeNodeAtPath,
  removeNodeAtPath,
  toggleExpandedForAll,
} from "@nosferatu500/react-sortable-tree";
import "@nosferatu500/react-sortable-tree/style.css";
import React, { useEffect, useState } from "react";
import FileExplorerTheme from "react-sortable-tree-theme-full-node-drag";

import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import {
  EditMenu,
  GetAllMenus,
  GetApplications,
} from "../../../services/menu.service";
import { GetPermissionsSearch } from "../../../services/permission.service";
import DelMenuModal from "./DelMenuModal";
import SetNewMenuModal from "./SetNewMenuModal";
import TreeSkeleton from "./TreeSkeleton";

const MenuSortableTree = () => {
  const [treeData, setTreeData] = useState([
    {
      title: "افزودن منو",
      children: [],
      id: 0,
      parentOfficePostId: 0,
    },
  ]);

  const [openAddCategory, setOpenAddCategory] = useState(false);
  const [openDelCategory, setOpenDelCategory] = useState(false);
  const [rowInfo, setRowInfo] = useState();
  const [childOrSibling, setChildOrSibling] = useState();
  const [isFirstTimeView, setFirstTimeView] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [updateTree, setUpdateTree] = useState("");
  const [applicationOption, setApplicationOption] = useState([]);
  const [applicationValue, setApplicationValue] = useState("");
  const [permissionOption, setPermissionOption] = useState([]);
  const [searchById, setSearchById] = useState(false);

  const addNodeCild = (event, title) => {
    let { path } = event;
    let newTree = addNodeUnderParent({
      treeData: treeData,

      parentKey: path[path.length - 1],
      expandParent: true,

      getNodeKey: ({ treeIndex }) => treeIndex,

      newNode: {
        title: title,
        expanded: true,
      },
    });
    setTreeData(newTree.treeData);
  };

  function addNodeSibling(event, title) {
    let { path } = event;

    let newTree = addNodeUnderParent({
      treeData: treeData,
      parentKey: path[path.length - 2],
      expandParent: true,
      getNodeKey: ({ treeIndex }) => treeIndex,
      newNode: {
        title: title,
      },
    });

    setTreeData(newTree.treeData);
  }

  function removeNode(event) {
    const { path } = event;
    setTreeData(
      removeNodeAtPath({
        treeData,
        path,
        getNodeKey: ({ treeIndex }) => treeIndex,
      })
    );
  }

  function updateNode(event, title) {
    const { node, path } = event;
    const { children } = node;

    let newTree = changeNodeAtPath({
      treeData,
      path,
      getNodeKey: ({ treeIndex }) => treeIndex,
      newNode: {
        children,
        title: title,
      },
    });

    setTreeData(newTree);
  }

  const customSearchMethod = (node, searchQuery) => {
    let result;

    if (!isFirstTimeView) {
      if (searchById) {
        if (node.id.props) {
          result =
            searchQuery &&
            String(node.id.props.children[1])
              .toLowerCase()
              .indexOf(searchQuery) > -1;
        } else {
          result = searchQuery && String(node.id).indexOf(searchQuery) > -1;
        }
      } else {
        result = node.title.props
          ? searchQuery &&
            node.title.props.children[1]
              .toLowerCase()
              .indexOf(searchQuery.toLowerCase()) > -1
          : searchQuery &&
            node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
      }
    }

    return result;
  };

  function expand(expanded) {
    setTreeData(
      toggleExpandedForAll({
        treeData,
        expanded,
      })
    );
  }

  function expandAll() {
    expand(true);
  }

  function collapseAll() {
    expand(false);
  }

  const { mutate: GetAllMenusMutate, isLoading } = useMutation(GetAllMenus, {
    onSuccess: (data) => {
      if (data) {
        function getNestedChildren(arr, parent) {
          var children = [];
          for (var i = 0; i < arr.length; ++i) {
            if (arr[i].parentMenuId === parent.parentMenuId) {
              var grandChildren = getNestedChildren(arr[i].subMenus, {
                parentMenuId: arr[i].id,
              });

              if (grandChildren.length) {
                arr[i].children = grandChildren;
              }
              arr[i].expanded = true;
              children.push(arr[i]);
            }
          }
          return children;
        }
        var nest = getNestedChildren(data, { parentMenuId: null });

        setTreeData(nest);
        if (data.length > 0) {
          setFirstTimeView(false);
        }
      }
    },
    onError: () => {},
  });

  const { mutate: GetApplicationsMutate } = useMutation(GetApplications, {
    onSuccess: (data) => {
      if (data) {
        setApplicationOption(data);
      }
    },
    onError: () => {},
  });
  const { mutate: EditMenuMutate } = useMutation(EditMenu, {
    onSuccess: (data) => {
      if (data) {
        setUpdateTree(uuid());
      }
    },
    onError: () => {},
  });

  const { mutate: GetPermissionsSearchMutate } = useMutation(
    GetPermissionsSearch,
    {
      onSuccess: (data) => {
        if (data) {
          // DATA STORE IN STATE
          setPermissionOption(data);
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    GetApplicationsMutate();
  }, []);

  useEffect(() => {
    if (applicationValue)
      GetAllMenusMutate({
        applicationId: applicationValue,
      });
    setTimeout(() => {
      setSearchQuery("");
    }, 1000);
  }, [updateTree]);

  const handleMoveNode = (rowInfo) => {
    EditMenuMutate({
      name: "",
      title: rowInfo.node.title,
      id: rowInfo.node.id,
      parentMenuId:
        rowInfo.nextParentNode !== undefined ? rowInfo.nextParentNode.id : null,
      icon: rowInfo.node.icon,
      route: rowInfo.node.route,
      applicationId: rowInfo.node.applicationId,
      permissionId: rowInfo.node.permissionId,
    });
    setSearchById(true);
    setSearchQuery(rowInfo.node.id);
  };

  const handleSelectedDrop = (e) => {
    setApplicationValue(e.target.value);
    GetAllMenusMutate({
      applicationId: e.target.value,
    });
    GetPermissionsSearchMutate({
      permissionType: "Menu",
      applicationId: e.target.value,
    });
  };

  return (
    <>
      <Grid container flexDirection={"column"}>
        <Grid item className="dropdownCmp2-container">
          <DropdownCmp2
            style={{ paddingRight: "0 !important", maxWidth: "400px" }}
            onChange={handleSelectedDrop}
            value={applicationValue}
            label={"انتخاب سامانه*"}
            options={applicationOption}
            name="application"
            id="application"
          />
        </Grid>
        {applicationValue && (
          <>
            <Grid item width={"100%"}>
              <Box
                sx={{
                  borderTop: "2px solid #DAE0E4",
                  marginTop: "2rem",
                  paddingTop: "2rem",
                  marginBottom: "1rem",
                }}
              >
                <Grid item xs={12} maxWidth={"400px"}>
                  <Paper
                    elevation={0}
                    style={{
                      border: "1px solid #DAE0E4",
                      display: "flex",
                      width: "100%",
                      maxWidth: "400px",
                    }}
                    square={false}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1, paddingX: "16px" }}
                      placeholder="جستجو"
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setSearchById(false);
                      }}
                      value={searchById ? null : searchQuery}
                    />

                    <IconButton
                      type="button"
                      sx={{ color: "#9AAFC4" }}
                      aria-label="search"
                    >
                      <SearchIcon />
                    </IconButton>
                  </Paper>
                </Grid>
              </Box>
            </Grid>
            <Grid item>
              <div style={{ paddingRight: "2rem", display: "flex" }}>
                <Typography
                  // className="btnForm SuccessDefault"
                  sx={{
                    width: "fit-content",
                    cursor: "pointer",
                    color: "#1D4A87",
                    marginLeft: "5px",
                  }}
                  onClick={() => expandAll()}
                >
                  باز کردن همه
                </Typography>
                |
                <Typography
                  // className="btnForm SuccessDefault"
                  sx={{
                    width: "fit-content",
                    cursor: "pointer",
                    color: "#1D4A87",
                    marginRight: "5px",
                  }}
                  onClick={() => collapseAll()}
                >
                  بستن همه
                </Typography>
              </div>
            </Grid>
            <Grid item sx={{ height: "55vh" }} className="menuSortableTree">
              {!isLoading ? (
                <div
                  style={{
                    height: "100%",
                    marginTop: "15px",
                    direction: "rtl",
                  }}
                  className={!searchById ? "chartTree" : "chartTree-id"}
                >
                  <SortableTree
                    placeholderRenderer={() => {
                      setTreeData([
                        {
                          title: "افزودن منو",
                        },
                      ]);
                      setFirstTimeView(true);
                    }}
                    theme={FileExplorerTheme}
                    canDrag={() => true}
                    treeData={treeData}
                    onChange={(treeData) => setTreeData(treeData)}
                    rowDirection="rtl"
                    searchQuery={searchQuery}
                    searchFocusOffset={0}
                    searchMethod={({ node, searchQuery }) =>
                      customSearchMethod(node, searchQuery)
                    }
                    onMoveNode={(rowInfo) => handleMoveNode(rowInfo)}
                    generateNodeProps={(rowInfo) => ({
                      onClick: (event) => {},
                      buttons: [
                        <>
                          <div className="sortable-tree-container">
                            <Tooltip arrow title="افزودن منو">
                              <button
                                className="sortable-tree-btn"
                                onClick={(event) => {
                                  setRowInfo(rowInfo);
                                  setOpenAddCategory(true);
                                  isFirstTimeView
                                    ? setChildOrSibling("firstTime")
                                    : setChildOrSibling("sibling");
                                }}
                              >
                                <AddCircleOutlineIcon />
                              </button>
                            </Tooltip>
                            <Tooltip arrow title="افزودن زیر منو">
                              <button
                                className="sortable-tree-btn"
                                onClick={() => {
                                  setRowInfo(rowInfo);
                                  setOpenAddCategory(true);
                                  setChildOrSibling("child");
                                }}
                                disabled={isFirstTimeView}
                              >
                                <ControlPointDuplicateOutlinedIcon />
                              </button>
                            </Tooltip>
                            <Tooltip arrow title="ویرایش">
                              <button
                                className="sortable-tree-btn"
                                onClick={() => {
                                  setRowInfo(rowInfo);
                                  setOpenAddCategory(true);
                                  setChildOrSibling("update");
                                }}
                                disabled={isFirstTimeView}
                              >
                                <ModeEditOutlinedIcon />
                              </button>
                            </Tooltip>
                            {rowInfo.node.children === undefined && (
                              <Tooltip arrow title="حذف">
                                <button
                                  className="sortable-tree-btn-del"
                                  onClick={() => {
                                    setOpenDelCategory(true);
                                    setRowInfo(rowInfo);
                                  }}
                                  disabled={isFirstTimeView}
                                >
                                  <DeleteOutlineOutlinedIcon />
                                </button>
                              </Tooltip>
                            )}
                          </div>
                        </>,
                      ],
                      style: {
                        height: "40px",
                      },
                    })}
                  />
                </div>
              ) : (
                <TreeSkeleton />
              )}
            </Grid>
          </>
        )}
      </Grid>

      <SetNewMenuModal
        openAddCategory={openAddCategory}
        setOpenAddCategory={setOpenAddCategory}
        addNodeCild={addNodeCild}
        addNodeSibling={addNodeSibling}
        updateNode={updateNode}
        rowInfo={rowInfo}
        childOrSibling={childOrSibling}
        setFirstTimeView={setFirstTimeView}
        setUpdateTree={setUpdateTree}
        permissionOption={permissionOption}
        applicationId={applicationValue}
        setSearchQuery={setSearchQuery}
        setSearchById={setSearchById}
      />
      <DelMenuModal
        openDelCategory={openDelCategory}
        setOpenDelCategory={setOpenDelCategory}
        rowInfo={rowInfo}
        setUpdateTree={setUpdateTree}
      />
    </>
  );
};

export default MenuSortableTree;
